<template>
  <div class="dialog-add-app-extend-wrapper">
    <el-dialog title="添加应用扩展字段" width="50%" :visible="visible" @open="onDialogOpen" @close="onDialogClose">

      <el-form label-position="top" ref="form" class="form" :rules="formRules" :model="form">
        <el-form-item label="字段名称" prop="extend_param_name" >
          <el-input v-model="form.extend_param_name" />
        </el-form-item>

        <el-form-item label="所属应用" prop="app_store_id">
          <el-select
            filterable
            default-first-option
            v-model="form.app_store_id">
            <el-option
              v-for="app in appList"
              :key="app.app_store_id"
              :label="app.app_name_i18n[0].name"
              :value="app.app_store_id" />
          </el-select>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="form.remarks" />
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onFormSubmit">确定</el-button>
          <el-button @click="onFormCancel">取消</el-button>
        </el-form-item>

      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogAddAppExtend',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      formRules: {
        extend_param_name: [
          { required: true, message: '请输入扩展字段名称', trigger: 'blur' }
        ],
        app_store_id: [
          { required: true, message: '请选择扩展字段所属应用', trigger: 'change' }
        ],
        remarks: [
          { required: true, message: '请输入扩展字段名称', trigger: 'blur' }
        ]
      },
      form: {
        extend_param_name: '',
        app_store_id: '',
        remarks: ''
      }
    }
  },
  computed: {
    ...mapState('store', [
      'appList'
    ])
  },
  methods: {
    ...mapActions('store', [
      'addAppExtendParam'
    ]),

    // 整理表单，验证数据
    cleanFormAndSubmit () {
      const clean = JSON.parse(JSON.stringify(this.form))

      // 提交表单
      this.performSubmit(clean)
    },
    async performSubmit (cleanForm) {
      try {
        await this.addAppExtendParam(cleanForm)

        this.$refs['form'].resetFields()
        this.$emit('update:visible', false)
        this.$emit('data-change')
      } catch (err) {
        this.$message({
          type: 'error',
          message: '添加应用扩展字段失败'
        })
        console.log(err)
      }
    },

    onFormSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.cleanFormAndSubmit()
        }
      })
    },
    onFormCancel () {
      this.$refs['form'].resetFields()
      this.$emit('update:visible', false)
    },

    onDialogOpen () {
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/base.scss';

.dialog-add-store-app-wrapper {
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/DialogAddAppExtend.vue